<template>
  <base-data-table
    :service-provider="serviceProvider"
    :vuex-module="vuexModule"
    :header-columns="headerColumns"
    :messages="messages"
    label="Companies"
    ref="datatable"
  >
    <template #header-right>
      <div class="navbar-search form-inline ml-auto mr-3">
        <b-form-group class="mb-0">
          <b-input-group class="input-group-alternative input-group-merge">
            <div class="input-group-prepend">
              <span class="input-group-text"
                ><i class="fas fa-search"></i
              ></span>
            </div>
            <b-form-input
              @input="onSearch"
              placeholder="Search"
              size="sm"
              type="text"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </div>
      <base-button
        @click.stop="
          $bus.$emit('toggle-modal', {
            key: 'add-company',
            active: true
          })
        "
        type="primary"
        size="sm"
        class="px-4"
        outline
        >Add Company</base-button
      >
    </template>

    <template v-slot:cell_company_admin_list="{ value, row }">
      <template v-if="value && 0 < value.length">
        <span class="text-info d-flex align-items-center">
          {{ value[0].is_superuser ? '*' : '' }} {{ value[0].name }}
          <template v-if="1 < value.length">
            <small
              v-if="`company-admin-list-${row.id}` !== collapsedColumn"
              class="ml-2"
              >{{ `+${value.length - 1}` }}</small
            >
            <a
              @click.stop.prevent="
                collapsedColumn =
                  `company-admin-list-${row.id}` !== collapsedColumn
                    ? `company-admin-list-${row.id}`
                    : null
              "
              class="px-2 ml-auto"
            >
              <b-icon
                :icon="
                  `company-admin-list-${row.id}` === collapsedColumn
                    ? 'caret-down-fill'
                    : 'caret-right-fill'
                "
              ></b-icon>
            </a>
          </template>
        </span>

        <b-collapse
          :visible="`company-admin-list-${row.id}` === collapsedColumn"
        >
          <span
            v-for="corp_admin in value.filter((item) => value[0] != item)"
            :key="corp_admin.id"
            class="text-info d-block"
            >{{ corp_admin.is_superuser ? '*' : '' }}
            {{ corp_admin.name }}</span
          >
        </b-collapse>
      </template>
      <template v-else>
        <span class="sr-only"></span>
      </template>
    </template>
    <template v-slot:cell_role="{ value }">{{
      value ? value.role : null
    }}</template>
    <template v-slot:cell_status="{ value, row }">
      <base-switch
        v-if="'Superuser' == $user.get().role"
        @input="
          switchStatus(
            'company',
            row,
            'Active' == value ? 'InActive' : 'Active'
          )
        "
        :value="'Active' == value"
        onText=""
        offText=""
      ></base-switch>
      <template v-else>{{ capitalizeText(value) }}</template>
    </template>
  </base-data-table>
</template>

<script>
import { debounce, capitalize } from 'lodash-es'
import { companiesTableData } from '@datas'
import { statusSwitchMixin } from '@mixins'

import BaseDataTable from '@components/BaseDataTable'

export default {
  name: 'table-companies',
  mixins: [statusSwitchMixin],
  components: {
    BaseDataTable
  },
  inject: ['companySvc', 'memberSvc'],
  data() {
    return {
      ...companiesTableData,
      collapsedColumn: null
    }
  },
  methods: {
    onSearch: debounce(function (keyword) {
      this.$bus.$emit('datatable-search', keyword)
    }, 500),
    capitalizeText(value) {
      return capitalize.value(value)
    }
  },
  created() {
    this.serviceProvider = this.companySvc
  },
  mounted() {
    this.$bus.trackEvent('datatable-cell-click', (row, column) => {
      if ('status' == column.property) return false

      if ('user_count' == column.property) {
        this.$router.push({
          name: 'ManageCompanyUsers',
          params: { id: row.id }
        })
      } else if ('report_count' == column.property) {
        this.$router.push({
          name: 'ManageCompanyReports',
          params: { id: row.id }
        })
      } else if (0 <= ['role', 'role_value'].indexOf(column.property)) {
        this.companySvc.set('company', row)

        this.$bus.$emit('toggle-modal', {
          key: 'company-role',
          active: true
        })
      } else {
        this.$router.push({
          name: 'ManageCompanyProfile',
          params: { id: row.id }
        })
      }
    })

    this.$bus.trackEvent('company-form-success', () => {
      this.companySvc.company.company_admin_list = []
      this.companySvc.company.user_count = 0
      this.companySvc.company.reports = []
      this.companySvc.company.report_count = 0

      this.companySvc.set('company', this.companySvc.company)
    })

    this.$bus.trackEvent('company-admin-form-success', () => {
      this.companySvc.company.company_admin_list = [
        {
          id: this.memberSvc.member.id,
          name: this.memberSvc.member.user.first_name,
          email: this.memberSvc.member.user.email
        }
      ]
      this.companySvc.company.user_count = 1

      this.companySvc.set('company', this.companySvc.company)
    })

    this.$bus.trackEvent('report-access-form-success', (payload) => {
      this.companySvc.company.reports = payload.map((item) => {
        return {
          report_id: item.id,
          report_assigned_id: item.assigned_items[0]
        }
      })
      this.companySvc.company.report_count += payload.length

      this.companySvc.set('company', this.companySvc.company)
    })
  },
  beforeDestroy() {
    this.$bus.destroyEvents()
  }
}
</script>
